import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FileDownloadService } from '@services/file-download.service';
import { FilenameParser } from '@utils/FilenameParser';
import { take } from 'rxjs/operators';
import { ListarPedidosService } from 'src/app/services/listar-pedidos.service';
import { AlertErroCustomizadoComponent } from '../../../components/alert-erro-customizado/alert-erro-customizado.component';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { FormsModule } from '@angular/forms';
import { SelectComponent } from '../../../components/select/select.component';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AppDatePipe } from '../../../pipes/app-date.pipe';

@Component({
    selector: 'app-alert-imprimir-recibo',
    templateUrl: './alert-imprimir-recibo.component.html',
    styleUrls: ['./alert-imprimir-recibo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertErroCustomizadoComponent, LoadingGenericoComponent, FormsModule, SelectComponent, PopoverDirective, AppDatePipe]
})
export class AlertImprimirReciboComponent implements OnInit {

  @Input() alertImprimirRecibo: boolean = false;
  @Output() alertImprimirReciboFechou = new EventEmitter();
  @Input() dadosPedido: any = null;
  @Input() idPedido: any;

  public idEmpresaLogada: any;
  public valorDigitado: any;
  public valorDigitadoInvalido: boolean = false;
  public valoresRetornados: any = null;
  public buscandoValores: any;
  public enderecosFaturamento: any = null;
  public departamentos: any = null;
  // INPUTS
  public usuarioSelecionado: any = '';
  public departamentoSelecionado: any = '';
  public ordenacaoSelecionado: any = '';
  public enderecoSelecionado: any = '';
  erroImpressaoRecibo: boolean;
  mensagemErro: any;
  tituloMensagemErro: any
  public loadingGenerico: boolean;
  public loadingGenericoMessage: string;


  constructor(private readonly service: ListarPedidosService) { }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.listarDepartamentos();
    this.listarEnderecosFaturamento();
  }

  fecharAlertImprimirRecibo() {
    this.usuarioSelecionado = '';
    this.departamentoSelecionado = '';
    this.ordenacaoSelecionado = '';
    this.enderecoSelecionado = '';
    this.valorDigitado = '';
    this.valoresRetornados = null;
    this.alertImprimirReciboFechou.emit('Fechou');
  }


  // LISTAR DEPARTAMENTOS
  listarDepartamentos() {
    this.service.listaDepartamentos(this.idEmpresaLogada, this.idPedido)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.departamentos = response.response;
      },
      error: (erro: any) => {
        console.error(erro);
        this.departamentos = false;
      }
    });
  }

  // LISTAR ENDEREÇOS DO SELECT
  listarEnderecosFaturamento() {
    this.service.listarEnderecosFaturamento(this.idEmpresaLogada, this.idPedido)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.enderecosFaturamento = response.response;
      },
      error: (erro: any) => {
        console.error(erro);
        this.enderecosFaturamento = false;
      }
    });
  }

  consultaCaracteres() {

    if (this.valorDigitado && this.valorDigitado.length > 3) {

      const input = document.querySelector<HTMLInputElement>('#caracteresUsuarios');
      if (input) {
        input.disabled = true;
      }

      this.buscandoValores = null;

      this.service.buscaUsuarioCaracter(this.dadosPedido.idPedido, this.valorDigitado)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.valoresRetornados = response.response;
          this.buscandoValores = true;
          const input = document.querySelector<HTMLInputElement>('#caracteresUsuarios');
          if (input) { input.disabled = false; }
        },
        error: (erro: any) => {
          console.error(erro);
          this.buscandoValores = false;
          const input = document.querySelector<HTMLInputElement>('#caracteresUsuarios');
          if (input) { input.disabled = false; }
        }
      });
    }
  }

  limparValoresRetornados() {
    this.valoresRetornados = null;
    this.usuarioSelecionado = '';
    this.valorDigitado = '';
  }

  // FUNÇÃO FINAL QUE VERIFICA OS VALORES E IMPRIME O RECIBO
  imprimirRecibo() {
    this.loadingGenerico = true;
    this.loadingGenericoMessage = 'Por favor, aguarde enquanto o PDF é gerado...';

    this.service.imprimirRecibo(this.dadosPedido.idPedido, this.usuarioSelecionado, this.departamentoSelecionado, this.ordenacaoSelecionado, this.enderecoSelecionado)
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.pdf',
        );
        FileDownloadService.download([body], filename);
        this.loadingGenerico = false;
      },
      error: (erro: any) => {
        this.mensagemErro = 'Favor tentar novamente com novos parâmetros';
        this.tituloMensagemErro = 'Nenhum registro encontrado';
        this.erroImpressaoRecibo = true;
        this.loadingGenerico = false;
      }
    });
  }
  fecharAlertError(evento: string){
    this.erroImpressaoRecibo = false;
  }
}
